import { memo } from 'react';

import { DateInput, type DateInputProps } from '@air/primitive-date-input';

export type DateRangeInputProps = {
  onStartDateChange: (date: Date | [Date, Date] | null) => void;
  onEndDateChange: (date: Date | [Date, Date] | null) => void;
  size: DateInputProps['size'];
  showCalendarIcon?: boolean;
  showClearButton?: boolean;
} & Pick<DateInputProps, 'startDate' | 'endDate'>;

export const DateRangeInput = memo(
  ({
    size,
    startDate,
    endDate,
    onEndDateChange,
    onStartDateChange,
    showCalendarIcon = true,
    showClearButton = true,
  }: DateRangeInputProps) => {
    return (
      <div className="flex items-center">
        <DateInput
          endDate={endDate}
          maxDate={endDate ?? new Date()}
          name="startDate"
          onChange={onStartDateChange}
          selected={startDate}
          selectsRange
          showCalendarIcon={showCalendarIcon}
          showClearButton={showClearButton}
          size={size}
          startDate={startDate}
        />
        <div className="mx-2.5 h-0.5 w-3 rounded-2 bg-gray-9" />
        <DateInput
          endDate={endDate}
          minDate={startDate ?? undefined}
          name="endDate"
          onChange={onEndDateChange}
          selected={endDate}
          selectsEnd
          showCalendarIcon={showCalendarIcon}
          showClearButton={showClearButton}
          size={size}
          startDate={startDate}
        />
      </div>
    );
  },
);

DateRangeInput.displayName = 'DateRangeInput';
